import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";

export const useGetBuyerCommunicationQuery = () => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_BUYER_COMMS],
    queryFn: () => api.get(API_ROUTES.GET_BUYER_COMMS),
  });
  return { data: data?.data?.data ?? [], isPending, isError, error };
};

export const useAnalyzeConversationMutation = () => {
  const queryClient = useQueryClient();
  const {
    mutate,
    data,
    isPending,
    isError,
    error,
    isSuccess
  } = useMutation({
    mutationFn: (payload) => api.post(API_ROUTES.ANALYZE_CONVERSATION, payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries([API_ROUTES.GET_BUYER_COMMS]);
      
      console.log('Analysis completed successfully:', data);
    },
    onError: (error) => {
      console.error('Error analyzing conversation:', error);
    }
  });
  
  return { mutate, data, isPending, isError, error, isSuccess };
};

export const useGenerateUpdatedPromptMutation = () => {
  const {
    mutate,
    data,
    isPending,
    isError,
    error,
    isSuccess,
    reset
  } = useMutation({
    mutationFn: (payload) => api.post(API_ROUTES.GENERATE_UPDATED_PROMPT, payload),
  });
  
  return { mutate, data, isPending, isError, error, isSuccess, reset };
};

